import type { FC } from 'react';
import { useTheme } from '@mui/material/styles';
import { useCompanySettings } from 'src/hooks/use-company-settings';

export const Logo: FC = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const { settings: company } = useCompanySettings();

  // Use uploaded company logos with static fallbacks
  const logoSrc = isDarkMode
    ? (company.logoDarkUrl || '/assets/relightlogo.png')
    : (company.logoUrl || '/assets/logo.png');

  return (
    <img
      src={logoSrc}
      alt={`${company.companyName || 'Relight'} Logo`}
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'contain',
      }}
    />
  );
};
